<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="样式名称">
              <a-input v-model="query.styleName" placeholder="请输入样式名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="样式类型">
              <a-select v-model="query.styleType" placeholder="请输入样式类型" allow-clear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="1">点</a-select-option>
                <a-select-option :value="2">线</a-select-option>
                <a-select-option :value="3">面</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()"   v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()"   v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"   v-action:edit>编辑</a>
      </span>
      <div slot="styleType" slot-scope="text">
        <span v-if="text===1">点</span>
        <span v-if="text===2">线</span>
        <span v-if="text===3">面</span>
      </div>
      <div slot="stylePreview" slot-scope="text, record">
        <div v-if="record.styleType===1" style="width:50px;height:50px;border-radius:4px;background:#ECEFF3;display:flex;justify-content: center;align-items: center;">
          <img :src="text" width="50" height="50" alt="加载失败"/>
        </div>
        <div v-if="record.styleType===2" style="width:50px;height:50px;">
          <svg style="margin-left: -10px;width:100%; height:50%">
            <g fill="none" :stroke="text | lineStyle1">
              <path :stroke-width="text | lineStyle2" d="M0 15 l65 0" :stroke-dasharray='text | lineStyle3'/>
            </g>
          </svg>
          <svg style="margin-left: -10px;width:100%; height:50%" viewBox="-3 2 22 3">
            <g fill="none" :stroke="text | lineStyle1">
              <path d="M3,5 l1,-3 l1,3" :stroke-linejoin='text | lineStyle4'/>
            </g>
          </svg>
        </div>
        <div v-if="record.styleType===3" style="width:50px;height:50px;" :style="text | layerStyle"></div>
      </div>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model class="log-form" ref="addOrUpdateForm" :model="addOrUpdateForm" :rules="rules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="样式名称"
          prop="styleName"
        >
          <a-input placeholder="样式名称" v-model="addOrUpdateForm.styleName" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="样式类型">
          <a-select placeholder="请选择样式类型" v-model="addOrUpdateForm.styleType">
            <a-select-option :value="1" :key="1">点</a-select-option>
            <a-select-option :value="2" :key="2">线</a-select-option>
            <a-select-option :value="3" :key="3">面</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 点 -->
        <a-form-model-item
          v-if="addOrUpdateForm.styleType===1"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="样式设置"
        >
          <a-upload
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :headers="headers"
            :action="uploadFileUrl"
            @change="handleChange"
          >
            <img v-if="addOrUpdateForm.styleValue" :src="addOrUpdateForm.styleValue" alt="avatar" width="50px" height="50px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传图标
              </div>
            </div>
          </a-upload>
        </a-form-model-item>
        <!-- 线 -->
        <a-form-model-item
          v-if="addOrUpdateForm.styleType === 2"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="样式设置"
        >
          <div class="set-box">
            <div class="left-box">
              <div class="preview-box">
                <div class="svg-box">
                  <svg>
                    <g fill="none" :stroke="borderColor">
                      <path
                        :stroke-width="borderSize"
                        d="M5 50 l140 0"
                        :stroke-dasharray="dasharray"
                      />
                    </g>
                  </svg>
                </div>
                <div class="svg-box">
                  <svg viewBox="-1 3 16 1">
                    <path
                      d="M6,5 l1,-3 l1,3"
                      :stroke="borderColor"
                      fill="none"
                      :stroke-linejoin="strokelinejoin"
                    />
                  </svg>
                </div>
              </div>
              <div class="clear-style" @click="clearStyle">清除样式</div>
            </div>
            <div class="right-box">
              <div style="margin-top:20px">
                <span>颜色</span>
              </div>
              <div style="margin-top:20px">
                <colorPicker v-model="borderColor" />
              </div>
              <div style="margin-top:20px">
                <span>宽度</span>
                <a-input-number v-model="borderSize" />
              </div>
              <div style="margin-top:20px">
                <span>虚线长度及间距</span>
                <a-input-number v-model="dasharray" placeholder />
              </div>
              <div style="height:100px;margin-top:20px">
                <span style="float:left;line-height:30px">转角</span>
                <a-select
                  style="width: 120px"
                  v-model="strokelinejoin"
                  label="转角类型"
                  placeholder="请选择"
                >
                  <a-select-option value="round">圆角</a-select-option>
                  <a-select-option value="miter">尖角</a-select-option>
                  <a-select-option value="bevel">斜角</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-form-model-item>
        <!-- 面 -->
        <a-form-model-item
          v-if="addOrUpdateForm.styleType===3"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="样式设置"
        >
          <div class="set-box">
            <div class="left-box">
              <div class="preview-box">
                <div class="layerStyle" :style="layerStyleConvert"></div>
              </div>
              <div class="clear-style" @click="clearStyle">清除样式</div>
            </div>
            <div class="right-box">
              <div style="margin-top:20px">
                <span>边框颜色</span>
              </div>
              <div style="margin-top:20px">
                <colorPicker v-model="strokecolor" />
              </div>
              <div style="margin-top:20px">
                <div>
                  <span>填充色</span>
                </div>
                <div style="margin-top:20px">
                  <colorPicker v-model="fillcolor" />
                </div>
              </div>
              <div style="margin-top:20px">
                <span>边框宽度</span>
                <a-input-number v-model="strokewidth" style="margin-left: 20px" />
              </div>
              <div style="margin-top:20px">
                <span>不透明度</span>
                <a-input-number v-model="fillopacity" style="margin-left: 20px" />
              </div>
            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input placeholder="备注" v-model="addOrUpdateForm.remark" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const columns = [
  {
    title: '样式名称',
    dataIndex: 'styleName'
  },
  {
    title: '样式类型',
    dataIndex: 'styleType',
    scopedSlots: { customRender: 'styleType' }
  },
  // {
  //   title: '样式值',
  //   dataIndex: 'styleValue',
  //   ellipsis: true
  // },
  {
    title: '样式预览',
    dataIndex: 'styleValue',
    scopedSlots: { customRender: 'stylePreview' }
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },

  {
    title: '操作',
    width: '100px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      strokewidth: '',
      fillopacity: '',
      fillcolor: '',
      strokecolor: '',
      strokelinejoin: 'round',
      dasharray: 0,
      borderSize: 1,
      borderColor: '',
      addOrUpdateForm: {
        styleName: '',
        styleType: 1,
        styleValue: '',
        remark: ''
      },
      currentId: '',
      queryUrl: '/manager/base-style/page',
      deleteUrl: '/manager/base-style',
      addOrUpdateUrl: '/manager/base-style',
      queryOneUrl: '/manager/base-style',
      uploadFileUrl: `${process.env.VUE_APP_API_BASE_URL}manager/file/resources/upload`,
      headers: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
      uploadLoading: false,
      query: {
        styleName: '',
        styleType: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      columns
    }
  },

  created () {},
  filters: {
    // 面样式展示
    layerStyle: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `background:${arrs[0]};border:${arrs[1]} ${arrs[3]}px solid; opacity:${arrs[2]}; width:50px`
    },
    lineStyle1: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[1]}`
    },
    lineStyle2: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[0]}`
    },
    lineStyle3: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[2]}`
    },
    lineStyle4: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[3]}`
    }
  },
  computed: {
    rules () {
      return {
        styleName: [{ required: true, message: '请输入样式名称' }]
      }
    },
    formStyle () {
      let borders = ''
      let background = ''
      let boxShadow = ''
      if (this.borderSize && this.borderColor) {
        borders = `border:${this.borderSize}px solid ${this.borderColor}`
      }
      if (this.bgColor) {
        background = `background:${this.bgColor}`
      }
      if (this.shadowColor) {
        boxShadow = `box-shadow:${this.xAxis}px ${this.yAxis}px ${this.vague}px ${this.extend}px ${this.shadowColor} ${this.shadowType}`
      }
      return `${borders};${background};${boxShadow};~[${this.borderSize},${this.borderColor},${this.bgColor},${this.xAxis},${this.yAxis},${this.vague},${this.extend},${this.shadowColor},${this.shadowType}]`
    },
    lineStyleConvert () {
      return `strokewidth:${this.borderSize};strokecolor:${this.borderColor};strokedasharray:${this.dasharray};strokelinejoin:${this.strokelinejoin};~[${this.borderSize},${this.borderColor},${this.dasharray},${this.strokelinejoin}]`
    },
    layerStyle () {
      let strowidth = ''
      let filcolor = ''
      let strocolor = ''
      let filopacity = ''
      if (this.strokewidth) {
        strowidth = `strokewidth:${this.strokewidth}`
      }
      if (this.fillcolor) {
        filcolor = `fillcolor:${this.fillcolor}`
      }
      if (this.strokecolor) {
        strocolor = `strokecolor:${this.strokecolor}`
      }
      if (this.fillopacity) {
        filopacity = `fillopacity:${this.fillopacity}`
      }
      return `${filcolor};${strocolor};${filopacity};${strowidth}`
    },
    layerStyleConvert () {
      let width = ''
      let filcolor = ''
      let strocolor = ''
      let filopacity = ''
      width = `width: 50px`
      if (this.fillcolor) {
        filcolor = `background:${this.fillcolor}`
      }
      if (this.strokecolor) {
        strocolor = `border:${this.strokecolor} ${this.strokewidth}px solid`
      }
      if (this.fillopacity) {
        filopacity = `opacity:${this.fillopacity}`
      }
      const convertValue = `${filcolor};${strocolor};${filopacity};${width}`
      console.log('转换: ', convertValue)
      return convertValue
    }
  },
  watch: {
    'addOrUpdateForm.styleType' (val) {
      this.$refs['addOrUpdateForm'].clearValidate()
    }
  },
  methods: {
    handleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
        this.uploadLoading = true
      }
      if (status === 'done') {
        if (info.file.response.code === 0) {
          this.addOrUpdateForm.styleValue = info.file.response.data.url
          this.$message.success(`${info.file.name} 文件上传成功.`)
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
        this.uploadLoading = false
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
        this.uploadLoading = false
      }
    },
    clearStyle () {
      this.borderColor = ''
      this.dasharray = 0
      this.strokelinejoin = 'round'
      this.bgColor = ''
      this.shadowColor = ''
      this.borderSize = '1'
      this.xAxis = 0
      this.yAxis = 0
      this.vague = 0
      this.extend = 0
      this.shadowType = 'inset'
      this.strokewidth = ''
      this.fillcolor = ''
      this.strokecolor = ''
      this.fillopacity = ''

    },

    detailInfo (record) {
      this.detailForm = { ...record }
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm={
        styleName: '',
        styleType: 1,
        styleValue: '',
        remark: ''
      },
        this.clearStyle()
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
        .get(`/manager/base-style/${this.currentId}`)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.addOrUpdateForm = {
            ...this.addOrUpdateForm,
            ...res.data
          }
          if (this.addOrUpdateForm.styleType === 3) {
            let arr2 = this.addOrUpdateForm.styleValue
            arr2 = arr2.split(';')
            const arrs = []
            arr2.forEach(item => {
              arrs.push(item.split(':')[1])
            })
            this.fillcolor = arrs[0]
            this.strokecolor = arrs[1].split(' ')[0]
            this.fillopacity = arrs[2]
            this.strokewidth = arrs[3].replace('px', '')
          } else if (this.addOrUpdateForm.styleType === 2) {
            let arr3 = this.addOrUpdateForm.styleValue
            arr3 = arr3.split(';')
            const arrs = []
            arr3.forEach(item => {
              arrs.push(item.split(':')[1])
            })
            this.borderSize = arrs[0]
            this.borderColor = arrs[1]
            this.dasharray = arrs[2]
          }
        })
        .catch(() => {})
    },
    handleOk (e) {
      e.preventDefault()

      this.$refs.addOrUpdateForm.validate(valid => {
        if (valid) {
          if (this.addOrUpdateForm.styleType === 2) {
            this.addOrUpdateForm.styleValue = this.lineStyleConvert
          } else if (this.addOrUpdateForm.styleType === 3) {
            this.addOrUpdateForm.styleValue = this.layerStyle
          } else if (this.addOrUpdateForm.styleType === 1) {

          }
          const params = { id: this.currentId, ...this.addOrUpdateForm }

          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then(res => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$refs.addOrUpdateForm.resetFields()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleCancel () {}
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.set-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 100%;
  height: 300px;
  line-height: 7px;
  display: flex;
  .left-box {
    height: 100%;
    width: 160px;
    margin-top: 16px;
    .preview-box {
      width: 118px;
      height: 50%;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .svg-box {
        height: 50%;
      }
    }
    .clear-style {
      margin-top: 10px;
      color: #999;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.preview-content {
  width: 9px;
  height: 9px;
}

.right-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 20px;
}
.right-box .el-form-item__content {
  line-height: 0;
}
.col-select {
  height: 1.5px;
  border-radius: 5px;
  background: #f3f3f3;
  display: flex;
  align-items: center;
}
.title-txt,
.right-txt {
  margin-left: 1.2px;
}
.edit-text {
  width: 9px;
  margin-left: 0.7px;
}
.edit-text input {
  width: 4.2px;
  border-style: none;
  background: transparent;
  text-align: right;
}

.tystyle {
  margin-left: 114px;
  margin-bottom: 30px;
}
.set-box svg {
  height: 100%;
  width: 100%;
}
.layerStyle {
  height: 50px;
  margin: 0 auto;
}
</style>
